module.exports = __webpack_public_path__ + "img/fund-home-3.4fa6bfa2.png";